<template>
  <el-dialog
      :visible.sync="dialogVisible"
      title="Add Feature Request"
      width="600px"
      :before-close="handleClose"
      @close="resetForm">
    <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-position="top">
      <el-form-item
          label="Title"
          prop="title">
        <el-input
            v-model="form.title"
            placeholder="Enter a short title for your feature request"
            maxlength="100"
            show-word-limit />
      </el-form-item>
      <el-form-item
          label="Description"
          prop="message">
        <el-input
            v-model="form.message"
            type="textarea"
            :rows="6"
            placeholder="Describe the feature you would like to request (minimum 10 characters)"
            maxlength="1000"
            show-word-limit />
      </el-form-item>
    </el-form>
    <span
        slot="footer"
        class="dialog-footer">
      <el-button @click="handleClose">Cancel</el-button>
      <el-button
          type="primary"
          :loading="submitting"
          @click="handleSubmit">
        Submit Request
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "AddFeatureRequestModal",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      submitting: false,
      form: {
        title: "",
        message: "",
      },
      rules: {
        title: [
          {
            required: true,
            message: "Please enter a title",
            trigger: "blur",
          },
          {
            min: 3,
            message: "Title must be at least 3 characters long",
            trigger: "blur",
          },
          {
            max: 100,
            message: "Title must not exceed 100 characters",
            trigger: "blur",
          },
        ],
        message: [
          {
            required: true,
            message: "Please enter a feature request description",
            trigger: "blur",
          },
          {
            min: 10,
            message: "Description must be at least 10 characters long",
            trigger: "blur",
          },
          {
            max: 1000,
            message: "Description must not exceed 1000 characters",
            trigger: "blur",
          },
        ],
      },
    };
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal;
    },
    dialogVisible(newVal) {
      this.$emit("update:visible", newVal);
    },
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
    },
    resetForm() {
      this.$refs.form.resetFields();
      this.form.title = "";
      this.form.message = "";
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitting = true;
          this.$store
            .dispatch("featureRequests/createFeatureRequest", {
              title: this.form.title.trim(),
              message: this.form.message.trim(),
            })
            .then(() => {
              this.$message({
                type: "success",
                message: "Feature request created successfully!",
                duration: 3000,
              });
              this.handleClose();
              this.$emit("created");
            })
            .catch((error) => {
              const message =
                error.response?.data?.message ||
                "Failed to create feature request. Please try again.";
              this.$message({
                type: "error",
                message,
                duration: 3000,
              });
            })
            .finally(() => {
              this.submitting = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #e4e4e4;
}

::v-deep .el-dialog__footer {
  border-top: 1px solid #e4e4e4;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>

